/**
 * biometricRecordsApi.js
 * ----------------------
 * API client for Education > Attendance > Biometric Records submodule.
 * Connects directly to FastAPI backend with zero mock data.
 */
import api from '../../../../api/client'

export async function fetchBiometricRecords(dateString, filters = {}, sortBy = 'sTime', sortOrder = 'desc') {
  const targetDate = dateString || new Date().toISOString().split('T')[0]

  const params = {
    date: targetDate,
    page: filters.page || 1,
    page_size: filters.pageSize || 100,
  }

  if (filters.academicYear && filters.academicYear !== 'All') {
    params.academic_year = filters.academicYear
  }
  if (filters.branch && filters.branch !== 'All' && !isNaN(filters.branch)) {
    params.branch_id = parseInt(filters.branch, 10)
  }
  if (filters.course && filters.course !== 'All' && !isNaN(filters.course)) {
    params.course_id = parseInt(filters.course, 10)
  }
  if (filters.batch && filters.batch !== 'All' && !isNaN(filters.batch)) {
    params.batch_id = parseInt(filters.batch, 10)
  }
  if (filters.school && filters.school !== 'All' && !isNaN(filters.school)) {
    params.school_id = parseInt(filters.school, 10)
  }

  // Legacy OrderBy: 1: sc.TDateTime DESC, 2: s.IDCardNo, 3: s.RollNo, 4: s.FullName, 5: s.BranchName
  let order_by = 1
  if (sortBy === 'idCardNo') order_by = 2
  else if (sortBy === 'rollNo') order_by = 3
  else if (sortBy === 'fullName') order_by = 4
  else if (sortBy === 'branchName') order_by = 5
  params.order_by = order_by

  const { data } = await api.get('/attendance/biometric', { params })
  const rawItems = data?.items || []
  const total = data?.total || rawItems.length

  const records = rawItems.map((r) => {
    // Determine IN vs OUT from time or device
    const timeStr = r.time || ''
    const hour = parseInt(timeStr.split(':')[0], 10) || 0
    const isOut = hour >= 13

    return {
      id: r.id,
      sTime: r.time,
      rawTime: r.time,
      timestamp: r.timestamp,
      date: r.date,
      swipeType: isOut ? 'OUT' : 'IN',
      idCardNo: r.id_card_no ? `CARD-${r.id_card_no}` : '',
      studentId: `STU-${r.id}`,
      fullName: r.full_name,
      rollNo: r.roll_no ? String(r.roll_no) : '',
      instituteName: r.institute_name,
      branchName: r.branch_name,
      courseName: '',
      batchNames: '',
      deviceId: r.device_id || 'Terminal-01 (Main Gate)',
      remark: r.remark || '',
    }
  })

  const uniqueStudentIds = new Set(records.map((s) => s.fullName))
  const inSwipes = records.filter((s) => s.swipeType === 'IN')
  const outSwipes = records.filter((s) => s.swipeType === 'OUT')
  const earliestSwipe = records.length > 0 ? records[0].sTime : '—'
  const latestSwipe = records.length > 0 ? records[records.length - 1].sTime : '—'

  return {
    records,
    totalRecords: total,
    metrics: {
      totalSwipes: total,
      uniqueStudents: uniqueStudentIds.size,
      inSwipesCount: inSwipes.length,
      outSwipesCount: outSwipes.length,
      earliestSwipe,
      latestSwipe,
    },
  }
}
